import { resolveCustomerType } from "../../../utlis/personTerminology";

export const DASHBOARD_TABS = [
  { id: "insights", labelKey: "nav_insights", icon: "insights" },
  { id: "metrics", labelKey: "nav_metrics", icon: "metrics" },
  { id: "monitor", labelKey: "nav_monitor", icon: "monitor" },
  { id: "action", labelKey: "nav_action", icon: "action" },
];

const REHAB_HIDDEN_TAB_IDS = new Set(["monitor", "action"]);

export const getDashboardTabs = (account) => {
  if (resolveCustomerType(account) === "rehab") {
    return DASHBOARD_TABS.map((tab) => ({
      ...tab,
      disabled: REHAB_HIDDEN_TAB_IDS.has(tab.id),
    }));
  }
  return DASHBOARD_TABS;
};
